module.exports = __webpack_public_path__ + "img/authorlevel3.d679ea40.png";